import { AccommodationList } from '@data/models';
import { apiCall, IRequestOptions } from '../axios';
import { Currencies, Languages } from '@data/types/common';

export class AccommodationsService {
  static search(
    params: {
      widget_property: number;
      checkin: string;
      checkout: string;
      lang: Languages;
      currency_code: Currencies;
    } = {} as any,
    options: IRequestOptions = {}
  ) {
    return new Promise<AccommodationList>((resolve, reject) => {
      const url = '/rooms';
      apiCall(AccommodationList)(
        'post',
        url,
        {
          ...params,
          currency_code: params.currency_code.toUpperCase(),
        },
        options
      )
        .then((res) => {
          const accommodationList = res;
          accommodationList.checkin = params.checkin;
          accommodationList.checkout = params.checkout;
          resolve(accommodationList);
        })
        .catch(reject);
    });
  }
}
